import { z } from 'zod';

const dashboardEventSchema = z.object({
    id: z.number().int().positive(),
    title: z.string().min(1),
    start: z.string(),
    end: z.string(),
});

export const dashboardEventMediaPreviewItemSchema = z.object({
    id: z.number().int().positive(),
    url: z.string().min(1),
    mime_type: z.string().min(1),
});

export const DashboardEventMediaItemSchema = z.object({
    event: dashboardEventSchema,
    media_count: z.number().int().nonnegative(),
    preview_media: z.array(dashboardEventMediaPreviewItemSchema).default([]),
});

export const dashboardEventMediaListSchema = z.array(DashboardEventMediaItemSchema);

export type DashboardEventMediaPreviewItem = z.infer<typeof dashboardEventMediaPreviewItemSchema>;
export type DashboardEventMediaItem = z.infer<typeof DashboardEventMediaItemSchema>;
